import {
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  type ModalProps,
} from "@chakra-ui/react";
import { t } from "@lingui/macro";
import type { AssignableFileUrlPair } from "@src/__generated__/urql-graphql";
import { Icon } from "@src/components/ui-kit/Icon";

interface Props extends ModalProps {
  title: string;
  originalUrl: NonNullable<AssignableFileUrlPair["original"]>;
}

export const MediaModal = ({
  title,
  originalUrl,
  children,
  ...props
}: Props) => {
  return (
    <Modal {...props} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {title}{" "}
          <IconButton
            pos="absolute"
            ml="4"
            aria-label={t`download`}
            colorScheme="grey"
            icon={<Icon name="download-02" boxSize="4" color="grey.500" />}
            onClick={() => {
              window.open(originalUrl, "_blank");
            }}
            size="sm"
            variant="outline"
          />
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>{children}</ModalBody>
      </ModalContent>
    </Modal>
  );
};
